import { defineMessages } from "react-intl";

export const scope = "components.DownloadActivityEscoCoupon";

export const messages = defineMessages({
  downloadButton: {
    id: `${scope}.downloadButton`,
    defaultMessage: "DESCARGAR BOLETO",
  },
});
